import { get } from '@/api/base'

export const getVersions = async (containerUuid, params) => {
  const response = await get({
    path: `versions/containers/${containerUuid}`,
    params,
  })
  return response.success
    ? {
        versions: response.data.versions,
        pagination: response.data.meta.pagination,
      }
    : null
}
